export const defaultPagiData = [
    {
        id: 'Pagination1',
        text: 'Previous'
    },
    {
        id: 'Pagination2',
        text: '1'
    },
    {
        id: 'Pagination3',
        text: "2"
    },
    {
        id: 'Pagination4',
        text: '3'
    },
    {
        id: 'Pagination5',
        text: 'Next'
    }
]

export const activeClassData= [
    {
        id: 'Pagination1',
        text: 'Previous'
    },
    {
        id: 'Pagination2',
        text: '1'
    },
    {
        id: 'Pagination3',
        text: "2" 
    },
    {
        id: 'Pagination4',
        text: '3'
    },
    {
        id: 'Pagination5',
        text: 'Next'
    }
]

export const iconListData = [
    {
        id: 'Pagination2',
        text: '1'
    },
    {
        id: 'Pagination3',
        text: '2'
    },
    {
        id: 'Pagination4',
        text: '3'
    },
    {
        id: 'Pagination5',
        text: '...'
    },
    {
        id: 'Pagination6',
        text: '20'
    }
]


export const alignPageData = ['Previous', '1', '2', '3', 'Next']
export const alignCenterData = ['Previous', 'I', 'II', 'III', 'Next']
export const alignbottomData = ['Previous', 'i ', 'ii ', 'iii', 'Next']